import type {TranslationFunction} from 'src/types/language-support';


export const EMAIL_DIGEST_ADDON_ID = 'email-digest-row';

export type EmailDigestMetadata = {
  list_id: string;
  entity_type: string;
  list_name?: string;
  filter_mode: 'recipient' | 'full' | '';
  join_attribute: string;
  preview_attributes?: {
    entityAttributeName: string;
    relations?: string[];
  }[];
  add_on_condition?: {
    [key: string]: string;
  };
  columns: string[];
};

export const buildEmailDigestTriggerParams = (
  metadata: EmailDigestMetadata,
): Record<string, unknown> => {
  return {
    filter_id: metadata.list_id,
    entity_type: metadata.entity_type,
    ...(metadata.list_name && {list_name: metadata.list_name}),
    filter_mode: metadata.filter_mode,
    join_attribute: metadata.join_attribute,
    preview_attributes: metadata.preview_attributes,
    ...(metadata.add_on_condition && {
      add_on_condition: metadata.add_on_condition,
    }),
  };
};

export function getEmailDigestBeefreeJson(
  t: TranslationFunction,
  response_key: string,
  metadata: EmailDigestMetadata,
) {
  const placeholder = `{{$.${response_key}.response.digest_content}}`;

  const modules = [
    {
      type: 'paragraph',
      html: getEmailDigestInfoBlockHTML(t),
    },
  ];

  const identifier = `{{$.fn.listDigestFormatter($.${response_key}.response.shortPreview.columns,$.${response_key}.response.shortPreview.data,$.${response_key}.response.downloadLink)}}`;

  const metadataPayload = buildEmailDigestTriggerParams(metadata);

  return {
    type: 'rowAddon',
    value: {
      name: 'emailDigestRowAddon',
      columns: [
        {
          weight: 12,
          modules,
        },
      ],
      metadata: {
        ...metadataPayload,
        variableIdentifier: identifier,
      },
    },
  };
}

const getEmailDigestInfoBlockHTML = (t: TranslationFunction) => `
  <div
    contenteditable="false"
    data-locked="true"
    style="background:#E6F0FE;border:1px solid #EBEBEB;padding:20px;display:flex;gap:12px;align-items:flex-start;user-select:none;"
  >
    <div style="display:flex;flex-direction:column;gap:8px;">
      <div style="font-family: 'Centra No 2', sans-serif;font-size:16px;color:#17172A;">${t(
        'Data_Table',
        'Data Table',
      )}</div>

      <div style="font-family: 'Centra No 2', sans-serif;font-size:12px;color:#17172A;">${t(
        'Data_with_the_selected_columns_will_be_shown_here',
        'Data with the selected columns will be shown here.',
      )}</div>
    </div>
  </div>
`;
